import MenuCategory from './MenuCategory'

export default MenuCategory
